import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { AuthContextProvider } from "./store/AuthContext";
import { DarkModeContextProvider } from "./store/darkModeContext";
import { LicenseInfo } from '@mui/x-license-pro';


LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE_KEY || '');

ReactDOM.render(
  <React.StrictMode>
    <DarkModeContextProvider>
      <AuthContextProvider>
        <App />
      </AuthContextProvider>
    </DarkModeContextProvider>
  </React.StrictMode>,
  document.getElementById("root")
);


